import { render } from "./IconRe.vue?vue&type=template&id=d2195090"
import script from "./IconRe.vue?vue&type=script&lang=js"
export * from "./IconRe.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__